export const marketKey = {
  get: (username: string) => ['market', username] as const,
  getCampaigns: (username: string, category: string) =>
    ['market', username, 'products', category] as const,
  getV2: (username: string) => ['market', username, 'v2'] as const,
  getV2Campaigns: (username: string, category: string) =>
    ['market', username, 'v2', 'products', category] as const,
};
